/**
 * @param {ReactNode} children - Contenido que se renderizará si se cumplen los requisitos de acceso.
 * @param {String} requiredModule - Nombre del módulo que se requiere para acceder a la ruta. (Opcional, por defecto `''`)
 * @returns {ReactNode} - Redirige al login si el usuario no tiene acceso, o muestra el contenido si tiene permiso.
 */
import { Navigate } from 'react-router-dom'
const ProtectedRoute = ({ children, requiredModule='' }) => {
  const token = localStorage.getItem('token')
  const usuario = JSON.parse(localStorage.getItem('user'))
  const permisos = JSON.parse(localStorage.getItem('permisos')) || []

  if (!token || !usuario) {
    // Si no hay token o usuario, redirigir al login
    return <Navigate to="/" />
  }

  // Buscar el permiso correspondiente al módulo requerido
  const permisoModulo = permisos.find(permiso => permiso.module === requiredModule)

  // Si no hay permiso para ese módulo o el acceso es false, redirigir al login
  if(requiredModule=='')
  {
    return children
  }
  else if (!permisoModulo || !permisoModulo.acceso ) {
    return <Navigate to="/" />
  }

  // Si pasa todas las validaciones, se renderiza el contenido protegido
  return children
}

export default ProtectedRoute
